import React from "react";
import { KTMScreen, ActionEvent, RenderEvent, renderScreen } from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Layout, Dialog, Button, Column, Panel, Display, Card } from "ktm-ui";

interface IdsBenefit {
  Id: string;
  Policy_Id: string;
  BenefitType_Id: string;
  AccrualFrequency: string;
  NextYearAccrualFrequency: string;
}

export default KTMScreen(
  { name: "enroll.product.edit-accrual-frequency" },
  class extends React.Component<{ policyBenefit_id: string,  policy_id: string }> {
    data: {
      dsBenefit: IdsBenefit;
    };

    // Store original data for comparison
    originalData: IdsBenefit | null = null;

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsBenefit";
      await KTMApi.start(screen, {
        "@policyBenefit_id": this.props.policyBenefit_id,
      });

     // Store a copy of the original data
     this.originalData = { ...this.data.dsBenefit };
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout>
          {draw(this.header)}
          {draw(this.main_tab)}
          {draw(this.footer)}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return <Dialog.Header label="Edit Scheduled Credits" />;
    }

    footer({ field, draw, action }: RenderEvent) {
      return (
        <Dialog.Footer>
          <Button
            action={action(this.submit)}
            label="Save"
            size="large"
            style="primary"
          />
        </Dialog.Footer>
      );
    }

    main_tab({ field, draw, action }: RenderEvent) {
      return (
        <Panel>
            <Column>{draw(this.details)}</Column>
        </Panel>
      );
    }

    details({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Display field={field("AccrualFrequency")} />
        </Card>
      );
    }

    getChangedFields(originalData, updatedData) {
      if (!originalData) return {};

      const changes = {};
      for (const key in updatedData) {
        if (updatedData[key] !== originalData[key]) {
          changes[key] = {
            oldValue:
              originalData[key] !== undefined ? originalData[key] : "N/A",
            newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
          };
        }
      }
      return changes;
    }

    async submit({ screen }: ActionEvent) {
     
        if (this.data.dsBenefit.AccrualFrequency === "None") {
            this.data.dsBenefit.AccrualFrequency = null;
        }

        // Track changes
        const changes = this.getChangedFields(
            this.originalData,
            this.data.dsBenefit
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Update General settings",
            PolicyBenefitId: this.props.policyBenefit_id,
            }),
        };

        await KTMApi.action(screen, "submit", {
            "@dsBenefit.BenefitType_Id": this.data.dsBenefit.BenefitType_Id,
            "@dsBenefit.AccrualFrequency": this.data.dsBenefit.AccrualFrequency,
            "@policyBenefit_id": this.props.policyBenefit_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({ continue: true });
        }
    }
);
